export default {
  state: {
    content: null,
    color: null
  },
  mutations: {
    SET_MESSAGE(state, payload) {
      state.content = payload.content
      state.color = payload.color
    }
  }
}
